import { render, staticRenderFns } from "./PreviewComments.vue?vue&type=template&id=293be1b9"
import script from "./PreviewComments.vue?vue&type=script&lang=js"
export * from "./PreviewComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports